import React from "react";
import { Button, Tooltip, Image } from "@nextui-org/react";
import { IconRefresh, IconMaximize, IconMinimize } from "@tabler/icons-react";
import { observer } from "mobx-react-lite";
import synkChainScanPageStore from "../store/store.SynkChainScanPage";

interface BrowserControlsProps {
  onRefresh: () => void;

  onFullscreen: () => void;
}

const BrowserControls: React.FC<BrowserControlsProps> = observer(
  ({ onRefresh, onFullscreen }) => {
    const handleFullscreen = () => {
      synkChainScanPageStore.toggleSidebar();
      onFullscreen();
    };

    return (
      <div className="flex h-12 w-full items-center justify-between gap-2 px-4">
        <div className="flex items-center gap-2">
          <Tooltip
            content="Restart the browser session"
            delay={1000}
            classNames={{
              content: ["bg-customGray/80 backdrop-blur-custom"],
            }}
          >
            <Button isIconOnly size="sm" variant="light" onClick={onRefresh}>
              <IconRefresh
                className={`h-4 w-4 ${
                  synkChainScanPageStore.isDarkMode
                    ? "text-white"
                    : "text-black"
                }`}
              />
            </Button>
          </Tooltip>
        </div>

        <div
          className={`rounded-small flex h-8 min-w-52 items-center justify-center px-2 sm:min-w-[320px] ${
            synkChainScanPageStore.isDarkMode ? "bg-black" : "bg-white"
          }`}
        >
          <div className="flex items-center gap-2">
            <Image
              src="/images/app/SynkStore/StoreSynk.jpg"
              alt="Synk Logo"
              width={16}
              height={16}
              className="object-contain"
            />
            <span
              className={`inline text-xs uppercase ${
                synkChainScanPageStore.isDarkMode
                  ? "text-white"
                  : "text-default-400"
              }`}
            >
              Synk Protection
            </span>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Tooltip
            content={
              synkChainScanPageStore.isSidebarOpen
                ? "Hide sidebar for more space"
                : "Show sidebar to switch explorers"
            }
            delay={1000}
            classNames={{
              content: ["bg-customGray/80 backdrop-blur-custom"],
            }}
          >
            <Button
              isIconOnly
              size="sm"
              variant="light"
              onClick={handleFullscreen}
            >
              {synkChainScanPageStore.isSidebarOpen ? (
                <IconMaximize
                  className={`h-4 w-4 ${
                    synkChainScanPageStore.isDarkMode
                      ? "text-white"
                      : "text-black"
                  }`}
                />
              ) : (
                <IconMinimize
                  className={`h-4 w-4 ${
                    synkChainScanPageStore.isDarkMode
                      ? "text-white"
                      : "text-black"
                  }`}
                />
              )}
            </Button>
          </Tooltip>
        </div>
      </div>
    );
  }
);

export default BrowserControls;
